import React, { useState, useEffect } from 'react';
import './Career.css';
import CareerService from '../../services/CareerService/CareerService';

import { useHistory } from 'react-router-dom';
import GearSpinner from '../../components/GearSpinner/GearSpinner';
import Loader from '../../components/Loader/Loader';

class Career extends React.Component {
  constructor(props) {
    super(props);
    this.messageRef = React.createRef();
    this.state = {
      jobs: [],
      loading: true,
      fields: {},
      errors: {},
      resume: null,
      cover_letter: null,
      isSubmit: 0,
      successMsg: '',
      apiError: '',
    };
  }

  scrollToMessage = () => {
    if (this.messageRef.current) {
      this.messageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  handleChange = (e) => {
    const { id, value } = e.target;

    this.setState((prevState) => ({
      fields: { ...prevState.fields, [id]: value },
      successMsg: '',
      apiError: '',
      errors: {
        ...prevState.errors,
        [id]: '',
      },
    }));
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    this.setState((prevState) => ({
      // resume: file,
      [name]: file,
      successMsg: '',
      apiError: '',
      errors: {
        ...prevState.errors,
        // resume: ""
        [name]: '',
      },
    }));
  };

  componentDidMount() {
    this.fetchJobs();
  }

  fetchJobs = async () => {
    this.setState({ loading: true });

    try {
      const response = await CareerService.getJobs();

      if (response?.data?.status === 'success') {
        this.setState({ jobs: response.data.result });
      } else {
        this.setState({ jobs: [] });
      }
    } catch (error) {
      console.error('Error fetching jobs:', error);
      this.setState({ jobs: [] });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleApply = (job) => {
    this.props.history.push(`/careers/${job.slug}`);
  };

  renderLoader = () => {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <GearSpinner />
      </div>
    );
  };

  renderNoJobs = () => {
    return (
      <div className="card infoBox text-center">
        <h4>No current openings</h4>
        <p>Please check back later.</p>
      </div>
    );
  };

  renderJobs = () => {
    const { jobs } = this.state;
    return jobs.map((job) => (
      <div className="job-card" key={job.id}>
        <div className="width-div">
          <div className="job-meta">
            {job.department} • {job.employment_type} • {job.location}
          </div>
          <h4>{job.title}</h4>
          <p>{job.short_description}</p>
        </div>

        <a href="#" className="btn dark" onClick={() => this.handleApply(job)}>
          Apply Now
        </a>
      </div>
    ));
  };

  validate = () => {
    let err = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9()\-\s]+$/;

    if (!this.state.fields.first_name || !this.state.fields.first_name.trim()) {
      err.first_name = 'First name is required';
    }

    if (!this.state.fields.last_name || !this.state.fields.last_name.trim()) {
      err.last_name = 'Last name is required';
    }

    if (
      !this.state.fields.email_address ||
      !this.state.fields.email_address.trim()
    ) {
      err.email_address = 'Email is required';
    } else if (!emailRegex.test(this.state.fields.email_address)) {
      err.email_address = 'Enter a valid email address';
    }

    if (
      !this.state.fields.phone_number ||
      !this.state.fields.phone_number.trim()
    ) {
      err.phone_number = 'Phone number is required';
    } else if (!phoneRegex.test(this.state.fields.phone_number)) {
      err.phone_number = 'Only numbers, space, (), - allowed';
    }

    if (
      !this.state.fields.position_interest ||
      !this.state.fields.position_interest.trim()
    ) {
      err.position_interest = 'Position is required';
    }

    if (!this.state.resume) {
      err.resume = 'Resume is required';
    }

    return err;
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = this.validate();

    if (Object.keys(validationErrors).length > 0) {
      this.setState({ errors: validationErrors });
      return;
    }

    this.setState({ errors: {}, apiError: '', successMsg: '', isSubmit: 1 });

    setTimeout(async () => {
      try {
        let formData = new FormData();
        formData.append('first_name', this.state.fields.first_name);
        formData.append('last_name', this.state.fields.last_name);
        formData.append('email', this.state.fields.email_address);
        formData.append('phone_number', this.state.fields.phone_number);
        formData.append('position', this.state.fields.position_interest);
        formData.append('note', this.state.fields.additional_comments || '');
        formData.append('resume', this.state.resume);
        if (this.state.cover_letter) {
          formData.append('cover_letter', this.state.cover_letter);
        }
        formData.append('job_id', '');

        const res = await CareerService.submitJobApplication(formData);

        if (res?.data?.status === 'success') {
          this.setState(
            {
              successMsg: 'Application submitted successfully!',
              fields: {
                first_name: '',
                last_name: '',
                email_address: '',
                phone_number: '',
                position_interest: '',
                additional_comments: '',
              },
              resume: null,
            },
            this.scrollToMessage
          );
        } else {
          this.setState(
            { apiError: res?.data?.message || 'Something went wrong.' },
            this.scrollToMessage
          );
        }
      } catch (err) {
        this.setState(
          { apiError: 'Server error. Please try again later.' },
          this.scrollToMessage
        );
      } finally {
        this.setState({ isSubmit: 0 });
      }
    }, 0);
  };

  render() {
    return (
      <div>
        <main className="techtop-middle-div" id="techtop-careers-section">
          <section className="hero careers-bg">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="hero-content">
                    <div className="badge">Careers at Techtop</div>
                    <h1>
                      Build your future with a team that keeps industry moving.
                    </h1>
                    <p>
                      At Techtop, we are committed to quality, innovation, and
                      service. We are always looking for motivated people who
                      want to grow their careers and make an impact.
                    </p>
                    <div className="hero-buttons">
                      {' '}
                      <a href="#openings" className="btn red">
                        View Open Positions
                      </a>{' '}
                      <a href="#apply" className="btn outline">
                        Submit Your Resume
                      </a>{' '}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="py-70">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <div className="card infoBox">
                    <h2 className="">Why Techtop?</h2>
                    <p>
                      We believe strong teams are built through collaboration,
                      accountability, and opportunity. Techtop offers a
                      professional environment where employees can learn,
                      contribute, and grow.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card infoBox">
                    <h2 className="">Our Culture</h2>
                    <p>
                      We value people who take initiative, communicate well, and
                      care about delivering results. From sales to operations,
                      every role helps support our customers and our long-term
                      success.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card infoBox">
                    <h2 className="">Growth Opportunities</h2>
                    <p>
                      Whether you are just starting out or bringing years of
                      experience, Techtop provides opportunities to build new
                      skills and grow within a stable, expanding organization.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="techtop-benefits-section py-70">
            <div className="container">
              <div className="row">
                <div className="col-md-6 align-self-center">
                  <h2>What you can expect</h2>
                  <p>
                    We are proud to offer a workplace focused on
                    professionalism, teamwork, and long-term success. Our
                    employees are an important part of what makes Techtop
                    strong.
                  </p>
                </div>
                <div className="col-md-6">
                  <div className="benefit-cards">
                    <div className="benefit">Competitive compensation</div>
                    <div className="benefit">Growth opportunities</div>
                    <div className="benefit">Team-focused environment</div>
                    <div className="benefit">Professional development</div>
                    <div className="benefit">
                      Comprehensive benefits package
                    </div>
                    <div className="benefit">Stable and growing company</div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="techtop-openings-section py-70" id="openings">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Current Open Positions</h2>
                  <div className="row">
                    <div className="col-md-7">
                      <p>
                        Explore current opportunities to join the Techtop team.
                      </p>
                    </div>
                    <div className="col-md-5">
                      <p className="text-end">Updated regularly by Techtop</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  {this.state.loading
                    ? this.renderLoader()
                    : this.state.jobs.length > 0
                      ? this.renderJobs()
                      : this.renderNoJobs()}
                </div>
              </div>
            </div>
          </section>

          <section className="techtop-apply-section py-70" id="apply">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="apply-width-div">
                    <h2>Apply to join Techtop</h2>
                    <p>
                      Interested in a career with Techtop? Complete the form
                      below and a member of our team will review your
                      information.
                    </p>
                    <div className="row mt-3">
                      <div className="col-md-12">
                        {this.state.isSubmit === 1 && (
                          <div className="text-center mb-3">
                            <Loader isLoading={true} />
                          </div>
                        )}

                        <form
                          className="apply-form"
                          onSubmit={this.handleSubmit}
                        >
                          <div ref={this.messageRef}>
                            {this.state.successMsg && (
                              <div className="alert alert-success">
                                {this.state.successMsg}
                              </div>
                            )}
                            {this.state.apiError && (
                              <div className="alert alert-danger">
                                {this.state.apiError}
                              </div>
                            )}
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  htmlFor="first_name"
                                  className="form-label"
                                >
                                  First Name*
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="first_name"
                                  placeholder="Enter first name"
                                  value={this.state.fields.first_name || ''}
                                  onChange={this.handleChange}
                                />
                                {this.state.errors.first_name && (
                                  <div className="text-danger">
                                    {this.state.errors.first_name}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  htmlFor="last_name"
                                  className="form-label"
                                >
                                  Last Name*
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="last_name"
                                  placeholder="Enter last name"
                                  value={this.state.fields.last_name || ''}
                                  onChange={this.handleChange}
                                />
                                {this.state.errors.last_name && (
                                  <div className="text-danger">
                                    {this.state.errors.last_name}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  htmlFor="email_address"
                                  className="form-label"
                                >
                                  Email Address*
                                </label>
                                <input
                                  type="email"
                                  className="form-control"
                                  id="email_address"
                                  placeholder="Enter email address"
                                  value={this.state.fields.email_address || ''}
                                  onChange={this.handleChange}
                                />
                                {this.state.errors.email_address && (
                                  <div className="text-danger">
                                    {this.state.errors.email_address}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  htmlFor="phone_number"
                                  className="form-label"
                                >
                                  Phone Number*
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="phone_number"
                                  placeholder="Enter phone number"
                                  value={this.state.fields.phone_number || ''}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    // allow only numbers, space, (), -
                                    if (/^[0-9()\-\s]*$/.test(value)) {
                                      this.handleChange(e);
                                    }
                                  }}
                                />
                                {this.state.errors.phone_number && (
                                  <div className="text-danger">
                                    {this.state.errors.phone_number}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="mb-3">
                                <label
                                  htmlFor="position_interest"
                                  className="form-label"
                                >
                                  Position of Interest*
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="position_interest"
                                  placeholder="Enter desired position"
                                  value={
                                    this.state.fields.position_interest || ''
                                  }
                                  onChange={this.handleChange}
                                />
                                {this.state.errors.position_interest && (
                                  <div className="text-danger">
                                    {this.state.errors.position_interest}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Resume Upload*
                                </label>
                                <label className="upload-box">
                                  <span className="upload-text">
                                    {this.state.resume
                                      ? this.state.resume.name
                                      : 'Upload resume here (PDF or DOCX)'}
                                  </span>
                                  <input
                                    type="file"
                                    name="resume"
                                    accept=".pdf,.doc,.docx"
                                    onChange={this.handleFileChange}
                                  />
                                </label>
                                {this.state.errors.resume && (
                                  <div className="text-danger">
                                    {this.state.errors.resume}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Cover Letter (Optional)
                                </label>
                                <label className="upload-box">
                                  <span className="upload-text">
                                    {this.state.cover_letter
                                      ? this.state.cover_letter.name
                                      : 'Upload cover letter (PDF or DOCX)'}
                                  </span>
                                  <input
                                    type="file"
                                    name="cover_letter" // ✅ IMPORTANT
                                    accept=".pdf,.doc,.docx"
                                    onChange={this.handleFileChange}
                                  />
                                </label>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label
                                  htmlFor="additional_comments"
                                  className="form-label"
                                >
                                  Additional Comments
                                </label>
                                <textarea
                                  rows="5"
                                  className="form-control"
                                  placeholder="Tell us a little about yourself"
                                  id="additional_comments"
                                  value={
                                    this.state.fields.additional_comments || ''
                                  }
                                  onChange={this.handleChange}
                                ></textarea>
                              </div>
                            </div>

                            <div className="col-md-12 mt-3">
                              <div className="submit-section">
                                <div className="submit-text">
                                  By submitting this form, you authorize Techtop
                                  to review your application for employment
                                  opportunities.
                                </div>
                                <button
                                  className="submit-btn"
                                  disabled={this.state.isSubmit}
                                >
                                  {this.state.isSubmit
                                    ? 'Submitting...'
                                    : 'Submit Application'}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    );
  }
}

export default Career;